module.exports = __webpack_public_path__ + "img/pantalla6-2.0c33f83a.png";